<section class="block-portada" [style.background-color]="backgroundColor || defaultBackgroundColor">
  <div class="container">
    <div class="row">
      <!-- Columna media (imagen) -->
      <div class="col-lg-6">
        <div class="portada-images">
          <div class="portada-images__main">
            <div *ngIf="loading" class="skeleton skeleton--image" style="height: 100%; min-height: 320px"></div>
            <img
              *ngIf="!loading"
              [src]="mainImage"
              [alt]="title"
              onError="this.src='assets/images/placeholder.svg'"
            />
          </div>
        </div>
      </div>

      <!-- Columna contenido -->
      <div class="col-lg-6">
        <div class="portada-content">
          <!-- Skeleton -->
          <ng-container *ngIf="loading">
            <div class="skeleton skeleton--title"></div>
            <div class="skeleton skeleton--text skeleton--line-60"></div>
            <div class="skeleton skeleton--text skeleton--line-80"></div>
            <div class="skeleton skeleton--text"></div>
            <div class="skeleton skeleton--text skeleton--line-60"></div>
          </ng-container>

          <h2
            *ngIf="!loading"
            class="portada-content__title titleTextFont"
            [innerHTML]="title | safeHtml"
          ></h2>
          <div
            *ngIf="!loading"
            class="portada-content__subtitle fadeIn mb-3 subtitle-block"
            style="font-size: 1.5rem; color: #3BB3C3; text-transform: uppercase; font-weight: 800;"
          >Nuestra propuesta académica</div>
          <div
            *ngIf="!loading"
            class="portada-content__description rich-text"
            [innerHTML]="description | safeHtml"
          ></div>

          <ul class="portada-links" *ngIf="!loading">
            <li *ngFor="let link of links; let i = index; trackBy: trackByLink"
                [class.is-open]="expandedLinkIndex === i">
              <button
                type="button"
                class="portada-link"
                [attr.aria-expanded]="expandedLinkIndex === i"
                [attr.aria-controls]="'portada-link-desc-' + i"
                (click)="toggleLink(i)">
                <span [innerHTML]="link.label | safeHtml"></span>
                <i class="fas fa-chevron-down portada-link__icon"
                   [style.color]="secondaryColor"></i>
              </button>
              <div
                class="portada-link__description"
                [id]="'portada-link-desc-' + i"
                [attr.aria-hidden]="expandedLinkIndex !== i"
                *ngIf="expandedLinkIndex === i">
                <div class="rich-text" [innerHTML]="link.description | safeHtml"></div>
              </div>
            </li>
          </ul>

          <div class="portada-actions" *ngIf="!loading">
            <a
              [href]="primaryButton.url"
              class="portada-actions__btn"
              [style.background-color]="secondaryColor"
            >
              {{ primaryButton.label }}
            </a>
            <a
              [href]="secondaryLink.url"
              class="portada-actions__link"
              [style.color]="linkColor || secondaryColor"
              (click)="onSecondaryClick($event)"
            >
              {{ secondaryLink.label }}
              <i class="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
